import { apiClient } from './apiClient';

export interface StockSimulatedPosition {
  id: number;
  symbol: string;
  name: string;
  entryPrice: number;
  entryTime: string;
  quantity?: number;
  status: 'OPEN' | 'CLOSED';
  exitPrice?: number;
  exitTime?: string;
  pnl?: number;
  pnlPercent?: number;
  metadata?: any;
  createdAt: string;
  updatedAt: string;
}

export interface StockSimulatedAccount {
  id: number;
  totalBalance: number;
  availableCash: number;
  frozenCash: number;
  totalEquity: number;
  cumulativePnl: number;
  pnlPercent: number;
  updatedAt: string;
}

class StockPortfolioService {
  /**
   * 获取账户详情
   */
  async getAccount(): Promise<StockSimulatedAccount> {
    const response = await apiClient.get<StockSimulatedAccount>('/stock/portfolio/account');

    if (!response.success) {
      throw new Error(response.message || '获取账户详情失败');
    }

    return response.data;
  }

  /**
   * 获取持仓列表
   */
  async getPositions(status?: 'OPEN' | 'CLOSED'): Promise<StockSimulatedPosition[]> {
    const response = await apiClient.get<StockSimulatedPosition[]>('/stock/portfolio/list', {
      params: { status },
    });

    if (!response.success) {
      throw new Error(response.message || '获取持仓列表失败');
    }

    return response.data;
  }

  /**
   * 开仓
   */
  async openPosition(data: {
    symbol: string;
    name: string;
    entryPrice: number;
    quantity?: number;
    metadata?: any;
  }): Promise<StockSimulatedPosition> {
    const response = await apiClient.post<StockSimulatedPosition>('/stock/portfolio/open', data);

    if (!response.success) {
      throw new Error(response.message || '开仓失败');
    }

    return response.data;
  }

  /**
   * 平仓
   */
  async closePosition(id: number, exitPrice: number): Promise<StockSimulatedPosition> {
    const response = await apiClient.post<StockSimulatedPosition>(`/stock/portfolio/close/${id}`, { exitPrice });

    if (!response.success) {
      throw new Error(response.message || '平仓失败');
    }

    return response.data;
  }

  /**
   * 手动更新实时盈亏
   */
  async updateLivePnL(): Promise<void> {
    const response = await apiClient.post<void>('/stock/portfolio/update-live-pnl');

    if (!response.success) {
      throw new Error(response.message || '更新实时盈亏失败');
    }

    return response.data;
  }
}

// 创建全局实例
export const stockPortfolioService = new StockPortfolioService();
